import React from 'react'

function Email(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 15.23"
            height={props.height}
            width={props.width}
        >
            <path
                fill={props.colorOne}
                d="M12.38 8.45l6.61 6.6c-.22.12-.48.19-.75.19H1.76c-.27 0-.53-.07-.76-.18l6.62-6.61 1.93 1.93a.58.58 0 00.83 0l2-1.93zM19.82 1c.11.22.18.48.18.75v11.72c0 .27-.07.52-.18.75l-6.6-6.61L19.81 1zM.18 1l6.6 6.6-6.6 6.62C.06 14 0 13.75 0 13.48V1.76c0-.27.07-.53.18-.76zM18.24 0c.27 0 .53.07.76.18L11.97 7.2l-2 1.93L1 .18C1.23.07 1.5 0 1.76 0h16.48z"
            />
        </svg>
    )
}

export default Email
